import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { theme } from 'theme'
import { NewTrans } from 'hooks/index'
import { Text } from 'rebass'
import { ApprovalOrderButton } from '../ActionButton'
import { selectWaitlistOrderMode, updateWaitlistOrderMode, APPROVE_ORDER_MODE } from 'state/registrations'
import { selectSelectedCampaignUuid } from 'state/review'
import RadioOption from './RadioOption'
import Menu from 'particles/Menu'
import MenuItem from 'particles/MenuItem'
import { useTranslation } from 'react-i18next'

const ApproveOrderTooltip: React.FC = () => {
    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
    const handleOpenMenu = (event?: React.MouseEvent<HTMLElement>) => {
        setMenuAnchorEl(event ? event.currentTarget : null)
    }
    const handleCloseMenu = () => {
        setMenuAnchorEl(null)
    }
    const [t] = useTranslation()
    const dispatch = useDispatch()
    const campaignUuid = useSelector(selectSelectedCampaignUuid)
    const waitlistOrderMode = useSelector(selectWaitlistOrderMode)
    const [mode, setMode] = useState<APPROVE_ORDER_MODE>(APPROVE_ORDER_MODE.REGISTRARION_TIME)
    useEffect(() => {
        if (waitlistOrderMode) {
            setMode(waitlistOrderMode)
        }
    }, [waitlistOrderMode])
    const handleUpdateWaitlistOrderMode = (waitlistMode: APPROVE_ORDER_MODE): void => {
        if (campaignUuid) {
            setMode(waitlistMode)
            dispatch(updateWaitlistOrderMode({ campaignUuid, waitlist_order_mode: waitlistMode }))
        }
    }
    return (
        <>
            <ApprovalOrderButton onClick={handleOpenMenu} />
            <Menu size="m" open={Boolean(menuAnchorEl)} anchorEl={menuAnchorEl} onClose={handleCloseMenu} width={324}>
                <NewTrans i18nKey="submission.review.waitlistApprovalOrderDescription">
                    <Text fontSize="14px" color={theme.colors.frenchRose}>
                        Partiposters in the waitlist will be approved in the <b>order selected.</b>
                    </Text>
                </NewTrans>
                <MenuItem.Divider />
                <RadioOption
                    onClickRadio={handleUpdateWaitlistOrderMode}
                    mode={mode}
                    radioMode={APPROVE_ORDER_MODE.REGISTRARION_TIME}
                    label={t(
                        'submission.review.table.waitlist.approvalOrder.approveByRegistrationDate.title',
                        'Approve by Registration Date',
                    )}
                    description={t(
                        'submission.review.table.waitlist.approvalOrder.approveByRegistrationDate.description',
                        'Partiposters will be approved based on their registration date (earliest to latest registered).',
                    )}
                />
                <RadioOption
                    onClickRadio={handleUpdateWaitlistOrderMode}
                    mode={mode}
                    radioMode={APPROVE_ORDER_MODE.WAITLISTED_TIME}
                    label={t(
                        'submission.review.table.waitlist.approvalOrder.approveByWaitlistedTime.title',
                        'Approve by Waitlisted Time',
                    )}
                    description={t(
                        'submission.review.table.waitlist.approvalOrder.approveByWaitlistedTime.description',
                        'Partiposters will be approved based on the time they have been added to the waitlist (earliest to latest added).',
                    )}
                />
            </Menu>
        </>
    )
}

export default ApproveOrderTooltip
